import React from 'react';
import { BookOpenIcon, FileCheck2Icon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { MOCKUP_IMAGE } from '../../data/content';
const badges = [{
  icon: ShieldCheckIcon,
  label: 'Basato sulle linee guida KDIGO'
}, {
  icon: FileCheck2Icon,
  label: 'PDF di alta qualità'
}, {
  icon: BookOpenIcon,
  label: 'Pronto per essere utilizzato oggi'
}];
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-10 pt-7 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-258" data-mp="mt91m1tkuyew">
      <div className="mx-auto max-w-3xl text-center" data-id="element-259" data-mp="quue3m279aok">
        <p className="font-display text-lg font-bold text-navy-deep sm:text-xl" data-id="element-260" data-mp="qt9hlqwbrho2">
          Dott.ssa <span className="text-kidney-dark" data-id="element-261" data-mp="vofa58k8ful4">Karito</span>
        </p>
        <p className="mt-1 text-[10.5px] font-extrabold uppercase tracking-[0.22em] text-navy/55 sm:text-xs" data-id="element-262" data-mp="10k45ezp7ypbm">
          Percorso Malattia Renale™
        </p>

        <h1 className="mt-6 font-display text-[30px] font-extrabold leading-[1.08] text-navy-deep sm:mt-8 sm:text-5xl md:text-[56px]" data-id="element-263" data-mp="1ajd3o4r4aq3s">
          Prendi decisioni sicure per qualsiasi paziente con malattia renale in{' '}
          <em className="not-italic text-kidney-dark" data-id="element-264" data-mp="4ogb57pcn2c5">meno di 5 minuti</em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-navy/75 sm:mt-6 sm:text-lg" data-id="element-265" data-mp="3vuhhj2ydd7rg">
          Dall’interpretazione di una creatinina elevata alla decisione di trattare,
          monitorare o inviare allo specialista, senza dover consultare molteplici
          linee guida né avere dubbi durante la visita.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-[13.5px] font-semibold leading-relaxed text-navy-deep sm:text-[15px]" data-id="element-266" data-mp="nfzfpiz0uoga">
          Più di 1.000 medici di lingua spagnola utilizzano già Percorso Malattia
          Renale™ per trasformare l’incertezza clinica in decisioni chiare e
          supportate dalle evidenze.
        </p>

        <div className="mt-7 sm:mt-10" data-id="element-267" data-mp="16e3d5g5jqz29">
          <img src={MOCKUP_IMAGE} alt="I 6 volumi di Percorso Malattia Renale™ con i 5 bonus esclusivi" className="mx-auto w-full max-w-[560px]" width={1080} height={1080} data-id="element-268" data-mp="16d0mn9c4yymv" />
        </div>

        <div className="mx-auto mt-2 max-w-md sm:mt-4" data-id="element-269" data-mp="2qw44dfmfs7vm">
          <CtaButton id="hero-cta" label="Voglio il Percorso Renale" sub="Download immediato • Pagamento unico • Accesso a vita • Garanzia di 7 giorni" data-id="element-270" data-mp="2qvkwysuex1vu" />
        </div>

        <ul className="mx-auto mt-7 flex max-w-md flex-col gap-2.5 sm:mt-9 sm:max-w-2xl sm:flex-row sm:justify-center sm:gap-6" data-id="element-271" data-mp="2hu4mkl3lkzrm">
          {badges.map(badge => <li key={badge.label} className="flex items-center justify-center gap-2 rounded-xl bg-white px-3 py-2.5 text-[12.5px] font-bold text-navy-deep sm:bg-transparent sm:px-0 sm:py-0 sm:text-[13px]" data-id="element-272" data-mp="27ybdjbp37oel">
              <badge.icon className="h-4 w-4 shrink-0 text-kidney-dark" aria-hidden="true" data-id="element-273" data-mp="642bh0j3ivv5" />
              {badge.label}
            </li>)}
        </ul>
      </div>
    </header>;
}